import React from 'react';
import { WhatsAppOutlined, PhoneOutlined } from '@ant-design/icons';

const FloatingActions = () => {
  return (
    <div className="floating-container">
      {/* Phone Button */}
      <a href="tel:9700213084" className="floating-btn phone-btn" title="Call Us">
        <PhoneOutlined />
      </a>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/+919700213084" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-btn whatsapp-btn"
        title="WhatsApp Us"
      >
        <WhatsAppOutlined />
      </a>
    </div>
  );
};

export default FloatingActions;